<template>
  <div id="first-login" v-if="showFirstLogin">
    <!-- <div id="first-login" v-if="showFirstLogin && !isPc()"> -->
    <!-- jp账号首次登录 弹出操作弹框 -->
    <div class="first-login-toast">
      <div class="detail">
        <div class="overflow-ct">
          <h1>温馨提示</h1>
          <div class="msg-icon"></div>
          <p>
            本次体验班级配套的
            <i>{{jpAccountTeacherInfo.student_count}}</i> 个体验学生账号与登录网址短信已发送到手机，请注意查收。
            本次体验结束后可自由开设班级、设置学生与学生人数。
          </p>
          <div class="chrome-icon"></div>
          <p>
            在电脑登录
            <i>{{jpAccountTeacherInfo.jp_url}}</i>
          </p>
          <p>可以体验更多{{system_sort_name()}}功能</p>
        </div>
        <div class="close-btn" @click="closeToast"></div>
      </div>
    </div>
    <!-- 组卷弹框 -->
    <!-- <el-dialog
      class="akadm-dialog-modal"
      title
      :show-close="false"
      :visible.sync="formVisiable"
      :close-on-click-modal="false"
    >
      <div class="form-title">
        <h1>欢迎进入{{system_sort_name()}}</h1>
        <p>请先设置您的个人信息</p>
      </div>
      <el-form :model="formData" ref="formData" @submit.native.prevent>
        <el-form-item label="用户名称" prop="name" :class="{'is-error':nameError}">
          <el-input
            ref="name"
            autocomplete="new-password"
            v-model="formData.name"
            maxlength="10"
            show-word-limit
            placeholder="请输入名称 "
            @input="inputAction('name')"
          ></el-input>
        </el-form-item>
        <el-form-item label="设置密码" prop="name" class="psw" :class="{'is-error':pswError}">
          <el-input
            autocomplete="new-password"
            ref="password"
            v-model="formData.password"
            :type="pswType"
            placeholder="请输入6位数的字母/数字"
            @input="inputAction('password')"
          ></el-input>
          <div class="wrap-eye" :class="{'close': pswType === 'password'}" @click="togglePswType"></div>
        </el-form-item>
      </el-form>
      <div class="error-tip" v-if="showError">{{errMsg}}</div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="sureModal"
          :loading="confirmLoading"
          :class="{'disabled':inputEmpty}"
        >确 定</el-button>
      </div>
    </el-dialog>-->
  </div>
</template>
<script>
// import organization from "@/mixin/organization.js";
import * as Api from "./indexApi";
export default {
  name: "firstLogin",
  // mixins: [organization],
  data() {
    return {
      confirmLoading: false,
      pswType: "password",
      showFirstLogin: false,
      formVisiable: false,
      formData: {
        name: "",
        password: ""
      },
      nameError: false,
      pswError: false,
      errMsg: "",
      showError: false,
      user_id: this.$cookies.get("user_id")
    };
  },
  computed: {
    inputEmpty() {
      return (
        this.formData.name.length == 0 || this.formData.password.length == 0
      );
    },
    isJpAccountAndFirstLogin() {
      return this.$store.getters.isJpAccountAndFirstLogin;
    },
    jpAccountTeacherInfo() {
      return this.$store.getters.jpAccountTeacherInfo;
    }
  },
  watch: {
    isJpAccountAndFirstLogin() {
      this.showFirstLogin =
        this.isJpAccountAndFirstLogin &&
        !this.isPc() &&
        !this.$cookies.get("close_first_login_toast");
    }
  },
  methods: {
    closeToast() {
      this.$cookies.set("close_first_login_toast", true);
      this.showFirstLogin = false;
    },
    initFormData() {
      setTimeout(() => {
        this.formData.name = "";
        this.formData.password = "";
      }, 0);
    },
    inputAction(value) {
      if (value == "name") {
        this.formData[value] = this.formData[value].replace(/\s+/g, "");
      } else if (value == "password") {
        this.formData[value] = this.formData[value].replace(/\s+/g, "");
        this.formData[value] = this.formData[value].replace(
          /[\u4e00-\u9fa5]/gi,
          ""
        );
      }
    },
    togglePswType() {
      this.pswType = this.pswType === "password" ? "text" : "password";
    },
    sureModal() {
      this.nameError = false;
      this.pswError = false;
      this.showError = false;
      if (!this.formData.name) {
        this.nameError = true;
        this.$refs.name.focus();
        return;
      }
      if (!this.formData.password) {
        this.pswError = true;
        this.$refs.password.focus();
        return;
      }
      if (!this.validatePassword(this.formData.password)) {
        this.showError = true;
        this.pswError = true;
        this.$refs.password.focus();
        this.errMsg = "密码长度6-18位,由数字，字母，特殊符号组成。";
        return;
      }

      let data = {
        org_code: this.org_code(),
        real_name: this.formData.name,
        password: this.formData.password
      };
      this.confirmLoading = true;
      Api.updateUserInfo(data)
        .then(res => {
          this.confirmLoading = false;
          if (res.errCode == 0) {
            // 是首次登陆 强制设置密码
            this.showFirstLogin = false;
            this.$message.success("重置成功！");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          this.confirmLoading = false;
          throw new Error(err);
        });
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
